import { CacheEntry, CacheEntryMetadata } from './CacheEntry';

/**
 * Check if a cache entry is fresh (within staleAgeMs)
 *
 * @param entry The cache entry or metadata to check
 * @param staleAgeMs Ideal freshness window in milliseconds
 * @param now Current timestamp in milliseconds
 * @returns true if the entry is fresh, false otherwise
 */
export const isCacheEntryFresh = (entry: CacheEntry | CacheEntryMetadata | undefined, staleAgeMs: number, now: number = Date.now()): boolean => {
  if (!entry) return false;
  const age = now - entry.createdAt;
  return age < staleAgeMs;
};
